module.exports = require("@swa-ui/dotcom/src/DotcomHeader/DotcomHeaderDesktop/LinkColumns.module.scss");